import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { CustomModalFooter } from 'src/components/custom_components/CustomModal';

import { I18NextNS } from 'src/models/Language.model';

export default function AnalyzingFooter() {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModalFooter>
      <Button
        variant="primary"
        disabled={true}
        data-track="exam.analyzing-modal.complete-exam"
        data-test="analyzing-modal-complete-exam"
        data-observe
      >
        {t('newExam.submit')}
      </Button>
    </CustomModalFooter>
  );
}
